import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Strada, StradaUpdate } from './strazi.interface';

@Injectable({
    providedIn: 'root'
})
export class StraziService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private storeStraziUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.storeStrada;
    private updateStraziUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.updateStrazi;
    private deleteStradaUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.deleteStrada;
    private getStraziPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.getStraziPublic;
    private getStraziActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.getStraziActive;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.changeStatusStraziActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.strazi.changeStatusStraziPublic;

    constructor(private http: HttpClient) { }

    addStrada(strada: Strada) {
        return this.http.post(this.storeStraziUrl, strada, this.httpOptions);
    }

    updateStrada(strada: StradaUpdate) {
        return this.http.put(this.updateStraziUrl, strada, this.httpOptions);
    }

    deleteStrada(id: number) {
        return this.http.delete(this.deleteStradaUrl + id);
    }

    getStraziActive() {
        return this.http.get(this.getStraziActiveUrl, this.httpOptions);
    }

    getStraziPublic() {
        return this.http.get(this.getStraziPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
